// /////////////////////////////////////////////////////////////
// [ファイル] getIdToken.ts
// [概要] Firebase の現在ユーザーの ID トークンを取得する共通ヘルパー。
//        Google Workspace 連携など、サーバー側で「リクエスト元 == インパーソネート対象」を
//        検証するエンドポイントで、Authorization: Bearer ヘッダーに付与して使う。
// /////////////////////////////////////////////////////////////
import { auth } from './firebase';

/**
 * 現在ログイン中ユーザーの Firebase ID トークンを返す。
 * 未ログインの場合は null。
 */
export const getIdToken = async (): Promise<string | null> => {
  const current = auth.currentUser;
  if (!current) return null;
  return current.getIdToken();
};
